var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-section" }, [
    _c("img", { staticClass: "picture", attrs: { src: _vm.PictureUrl } }),
    _c("h4", { domProps: { innerHTML: _vm._s(_vm.Title) } }),
    _c("h5", { domProps: { innerHTML: _vm._s(_vm.SubTitle) } }),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.DateStart.toLocaleString("fr-FR", {
            year: "numeric",
            month: "long",
            day: "numeric"
          })
        ) +
          " - " +
          _vm._s(
            _vm.DateEnd.toLocaleString("fr-FR", {
              year: "numeric",
              month: "long",
              day: "numeric"
            })
          )
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }